import { ProjectsProvider } from '@/providers/projects/projects.provider';
import { RoutingService } from '@/services/routing/routing.service';
import { AsyncPipe } from '@angular/common';
import { Component, type OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { type Observable, map } from 'rxjs';
import { AppShellV2Component } from './app-shell-v2/app-shell-v2.component';

@Component({
    selector: 'app-shell',
    templateUrl: 'app-shell.html',
    imports: [AppShellV2Component, RouterOutlet, AsyncPipe]
})
export class AppShellComponent implements OnInit {
    private _projectsProvider = inject(ProjectsProvider);
    private _routingService = inject(RoutingService);

    isChangingProject$!: Observable<boolean>;
    showShell$!: Observable<boolean>;
    customShell$!: Observable<boolean>;

    ngOnInit() {
        this.isChangingProject$ = this._projectsProvider.isChangingProject$();
        this.showShell$ = this._routingService.getActiveRoutesMergedData$().pipe(map(d => !d.standalone));
        this.customShell$ = this._routingService.getActiveRoutesMergedData$().pipe(map(d => d.customShell));
    }
}
